import React from "react";
import "../../styles/VisionMission.css";

export default function VisionMission() {
    return (
        <section className="vision-mission">
            <div className="container">
                <h2 className="section-title">Our Vision & Mission</h2>

                <div className="cards">
                    <div className="card">
                        <h3>Vision</h3>
                        <p>
                            To become a globally trusted pharmaceutical company that innovates and delivers quality healthcare solutions to improve lives.
                        </p>
                    </div>

                    <div className="card">
                        <h3>Mission</h3>
                        <p>
                            To research, manufacture, and distribute affordable and high-quality pharmaceutical products that meet international standards and serve communities worldwide.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
